module.exports = __webpack_public_path__ + "img/popup-bottom.58b57437.svg";